// src/components/ConfirmDialog.jsx (The final, memoized, and high-performance version)

import React from 'react';
import { createPortal } from 'react-dom';
import '../styles/ConfirmDialog.css';

// ✨ 1. 導入 React.memo ✨
const ConfirmDialog = React.memo(({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  isPending = false,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) => {
  // 如果 isOpen 為 false，則不渲染任何內容
  if (!isOpen) {
    return null;
  }

  const dialog = (
    <div className="confirm-overlay" onClick={isPending ? undefined : onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="confirm-actions">
          <button type="button" onClick={onConfirm} disabled={isPending}>
            {isPending ? 'Deleting...' : confirmText}
          </button>
          <button type="button" onClick={onCancel} disabled={isPending}>
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') {
    return dialog;
  }

  return createPortal(dialog, document.body);
});

export default ConfirmDialog;
